import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

//@Injectable({
//  providedIn: 'root'
//})
export abstract class BaseHttpService {

  protected baseUrl: string = '';
  protected apiKey: string = '';
  protected impersonationEmail?: string | null;
  public impersonatingName?: string | null;

  constructor(protected http: HttpClient) {

  }

  protected getAny(url: string, httpHeaders: HttpHeaders | undefined): Observable<any> {

    if (httpHeaders) {
      const httpOptions = { headers: httpHeaders };
      return this.http.get(url, httpOptions);
    }
    else {
      return this.http.get(url);
    }

  }

  protected postAny(content: any, url: string, httpHeaders: HttpHeaders | undefined): Observable<any> {

    if (httpHeaders) {
      const httpOptions = { headers: httpHeaders };
      return this.http.post(url, content, httpOptions);
    }
    else {
      return this.http.post(url, content);
    }

  }

  protected deleteAny(url: string, httpHeaders: HttpHeaders): Observable<any> {

    if (httpHeaders) {
      const httpOptions = { headers: httpHeaders };
      return this.http.delete(url, httpOptions);
    }
    else {
      return this.http.delete(url);
    }
  }

  protected putAny(content: any, url: string, httpHeaders: HttpHeaders): Observable<any> {

    if (httpHeaders) {
      const httpOptions = { headers: httpHeaders };
      return this.http.put(url, content, httpOptions);
    }
    else {
      return this.http.put(url, content);
    }
  }

  protected getItems<T>(url: string, httpHeaders?: HttpHeaders): Observable<T[]> {

    if (httpHeaders) {
      const httpOptions = { headers: httpHeaders };
      return this.http.get<T[]>(url, httpOptions);
    }
    else {
      return this.http.get<T[]>(url);
    }

  }

  protected getItem<T>(url: string, httpHeaders: HttpHeaders): Observable<T> {

    if (httpHeaders) {
      const httpOptions = { headers: httpHeaders };
      return this.http.get<T>(url, httpOptions);
    }
    else {
      return this.http.get<T>(url);
    }

  }

  protected removeItem<T>(_item: T, url: string, httpHeaders: HttpHeaders): Observable<boolean> {
    if (httpHeaders) {
      const httpOptions = { headers: httpHeaders };
      return this.http.delete<boolean>(url, httpOptions);
    }
    else {
      return this.http.delete<boolean>(url);
    }
  }

  protected saveItem<T>(item: T, isNew: boolean, url: string, httpHeaders?: HttpHeaders): Observable<boolean> {
    if (httpHeaders) {
      const httpOptions = { headers: httpHeaders };

      if (isNew)
        return this.http.post<boolean>(url, item, httpOptions);
      else
        return this.http.put<boolean>(url, item, httpOptions);
    }
    else {
      return this.http.post<boolean>(url, item);
    }
  }

  public getHttpBearerHeaders(token: string): HttpHeaders {

    if (this.impersonationEmail && this.impersonationEmail.length > 0) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'Ocp-Apim-Subscription-Key': this.apiKey,
        'Impersonating': this.impersonationEmail
      });
    }

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
      'Ocp-Apim-Subscription-Key': this.apiKey
    });

  }

  public getHttpBasicHeaders(basicToken: string): HttpHeaders {

    if (this.impersonationEmail && this.impersonationEmail.length > 0) {
      return new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + basicToken,
        'Ocp-Apim-Subscription-Key': this.apiKey,
        'Impersonating': this.impersonationEmail
      });
    }

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Basic ' + basicToken,
      'Ocp-Apim-Subscription-Key': this.apiKey
    });

  }

  public getImpersonatingEmail(): (string | null | undefined) {
    return this.impersonationEmail;
  }

  public setImpersonatingEmail(email?: string | null): void {
    this.impersonationEmail = email;
  }

  public resetImpersonationEmail(): void {
    this.impersonationEmail = null;
  }

}
